import React from 'react';
import { Button, Typography, Box } from '@mui/material';
import { navigate } from 'gatsby';

interface ButtonMarkProps {
  children: React.ReactNode;
  value?: {
    button: {
      buttonType: 'text' | 'outlined' | 'contained';
      link: {
        newTab: boolean;
        path: string;
        url: string;
      };
    };
  };
}

const ButtonMark = ({ children, value }: ButtonMarkProps) => {
  if (!value) return children;
  const link = value.button?.link;  
  if (!link) return children;

  const handleClick = () => {
    if (link.path) {
      navigate(link.path);
    } else if (link.url) {
      // Ensure window is defined (i.e., running in the browser and not during SSR)
      if (typeof window !== 'undefined') {
        if (link.newTab) {
          window.open(link.url, '_blank');
        } else {
          window.location.href = link.url;
        }
      }
    }
  };

  // console.log('BUTTON', value)

  if (link.path || link.url) {

    return (
      <>
        <Box alignSelf={'center'}>
          <Button          
            // Action
            onClick={handleClick}
            variant={value.button.buttonType}
            color="primary"
            size="large"            
          >
            <Typography variant="body2">{children}</Typography>
          </Button>
        </Box>
      </>
    );
  }

  return children;
};

export default ButtonMark;
